import React, { useState } from "react";

//CSS
import "./employeeAddPopup.css";
import "../../Pages/0PageStyles.css";

//Components
import InputField from "../Other Components/inputField";
import Button from "../Other Components/button";

//Functions and hooks
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import { useTranslation } from "react-i18next";

export default function EmployeeAddPopup({ onSend, onCancel }) {
  const [userIdentifier, setUserIdentifier] = useState("");
  const [body, setBody] = useState("");
  const isNarrow = useNarrowMode();

  const { t } = useTranslation();

  const handleIdentifierChange = (e) => {
    setUserIdentifier(e);
  };
  const handleBodyChange = (e) => {
    setBody(e);
  };
  return (
    <div className="employee-add-popup-container">
      <div className="employee-add-popup-background"></div>
      <div className="employee-add-popup">
        <InputField
          labelPosition={"top-left"}
          label={t("ID, Email or Username: ", { ns: "employees" })}
          value={userIdentifier}
          onChange={handleIdentifierChange}
        ></InputField>
        <InputField
          largeField={true}
          label={t("Additional message") + ":"}
          className=" h-auto"
          value={body}
          onChange={handleBodyChange}
        ></InputField>
        <div className="btn-container">
          <Button
            btnStyle={"btn-positive"}
            acceptEnter={true}
            icon="apply"
            className={isNarrow ? "mb-2" : ""}
            onClick={() => onSend(body, userIdentifier)}
          >
            {t("Send")}
          </Button>
          <Button onClick={onCancel}>{t("Cancel")}</Button>
        </div>
      </div>
    </div>
  );
}
